import { connect } from 'react-redux';

import {
    DatePickerContainer as SourceDatePickerContainer,
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps
} from 'SourceComponent/DatePicker/DatePicker.container';
import getStore from 'Util/Store';

/** @namespace Elganso/Component/DatePicker/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state)
    // TODO extend mapStateToProps
});

/** @namespace Elganso/Component/DatePicker/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch)
    // TODO extend mapDispatchToProps
});

/** @namespace Elganso/Component/DatePicker/Container */
export class DatePickerContainer extends SourceDatePickerContainer {
    containerProps() {
        const storeId = getStore().getState().ConfigReducer.id;

        let default_language = 'es';
        let default_format = 'dd/MM/yyyy HH:mm';

        switch (storeId) {
        case 0:
        case 1:
        case 4:
        case 10:
        case 12:
        case 13:
        case 14:
            default_language = 'es';
            default_format = 'dd/MM/yyyy HH:mm';
            break;
        case 2:
        case 5:
        case 7:
            default_language = 'en';
            default_format = 'MM/dd/yyyy HH:mm';
            break;
        case 3:
        case 6:
        case 9:
            default_language = 'fr';
            default_format = 'dd/MM/yyyy HH:mm';
            break;
        case 8:
            default_language = 'de';
            default_format = 'dd.MM.yyyy HH:mm';
            break;
        case 11:
            default_language = 'pt';
            default_format = 'dd/MM/yyyy HH:mm';
            break;
        default:
            default_language = 'es';
            default_format = 'dd/MM/yyyy HH:mm';
            break;
        }

        return {
            ...super.containerProps(),
            currentDate: new Date(),
            defaultLanguage: default_language,
            defaultFormat: default_format
        };
    }

    onSetDate(date) {
        const { updateSelectedValues } = this.props;

        this.setState({ selectedDate: date }, updateSelectedValues);
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DatePickerContainer);
